import { Component } from '@angular/core';
import {TranslocoPipe} from '@jsverse/transloco';
import {RouterLink} from '@angular/router';

@Component({
  selector: 'app-landing-testimonials',
  imports: [
    TranslocoPipe,
    RouterLink
  ],
  templateUrl: './landing-testimonials.component.html',
  styleUrl: './landing-testimonials.component.scss'
})
export class LandingTestimonialsComponent {

}
